// Hanging piece. The line's first move takes an enemy piece for free: the
// piece stood undefended, or is worth more than what takes it. When the
// line's net material is known (the fact's `lost` or `missed`), the piece
// taken must be the one it names, so a pawn taken on the way to a queen is
// not "a hanging pawn" (a discovered attack or a combination explains that
// line). The variation names the piece: the queen, a rook, a minor piece
// or a pawn.
import type { Motif } from '@chess/api-mistakes';
import type { TacticLine } from './line.ts';
import { defended, pieceClass, VALUE } from './rays.ts';

export function hangingPiece(line: TacticLine): Motif | undefined {
  const first = line.pv[0];
  if (!first) return undefined;
  const mover = line.board.get(first.slice(0, 2));
  const taken = line.board.captured(first);
  if (!mover || !taken || taken.colour !== line.victim || taken.kind === 'king') return undefined;
  const after = line.board.play(first);
  const free = !defended(after, first.slice(2, 4), line.victim) || VALUE[taken.kind] > VALUE[mover.kind];
  if (!free) return undefined;
  if (line.material && line.material !== 'mate' && line.material !== taken.kind) return undefined;
  const variation = pieceClass(taken.kind);
  return variation ? { family: 'hangingPiece', variation } : undefined;
}
